import { useState, useEffect } from 'react'
import { Navigation } from './components/navigation'
import { Header } from './components/header'
import { Features } from './components/features'
import { Gallery } from './components/gallery'
import { Contact } from './components/contact'
import { GruposDeTrabajo } from './components/GruposDeTrabajo/GruposDeTrabajo'
import JsonData from './data/data.json'
import SmoothScroll from 'smooth-scroll'
import './customStyles.scss'


export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
})


const App = () => {
  const [landingPageData, setLandingPageData] = useState({})
  useEffect(() => {
    setLandingPageData(JsonData)
  }, [])

  return (
    <div>
      <Navigation />
      <Header data={landingPageData.Header} />
      <GruposDeTrabajo />
      <Features data={landingPageData.Features} />
      {/* <About data={landingPageData.About} /> */}
      {/* <Services data={landingPageData.Services} /> */}
      <Gallery />
      {/*<Testimonials data={landingPageData.Testimonials} />
      <Team data={landingPageData.Team} />*/}
      <Contact data={landingPageData.Contact} />
    </div>
  )
}

export default App
